(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lcw-pdp-video"] && !Shopify.designMode) return;
  try {
    class LcwPdpVideo extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.lcw-pvideo__track');
      this.prevBtn = this.querySelector('[data-direction="prev"]');
      this.nextBtn = this.querySelector('[data-direction="next"]');
      this.trackingOn = this.dataset.tracking === 'true';
      this.autoplayOn = this.dataset.autoplay === 'true';
      this.listId = this.dataset.listId || 'lcw_pdp_video';

      this.bindArrows();
      this.bindSlides();
      this.setupCarouselAutoplay();
      this.setupImpressions();
      this.updateArrows();
      this.track && this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }

    bindArrows() {
      [this.prevBtn, this.nextBtn].forEach((btn) => {
        if (!btn) return;
        btn.addEventListener('click', () => {
          const dir = btn.dataset.direction === 'next' ? 1 : -1;
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        });
      });
    }

    updateArrows() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      this.prevBtn.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextBtn.toggleAttribute('disabled', scrollLeft >= scrollWidth - clientWidth - 1);
    }

    setupCarouselAutoplay() {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.autoplayOn || reduce) return;
      const vids = this.querySelectorAll('.lcw-pvideo__cvideo');
      if (!vids.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { v.muted = true; v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      vids.forEach((v) => io.observe(v));
    }

    bindSlides() {
      const slides = Array.from(this.querySelectorAll('.lcw-pvideo__slide'));
      slides.forEach((slide, idx) => {
        const trigger = slide.querySelector('.lcw-pvideo__trigger');
        const dialog = slide.querySelector('.lcw-pvideo__modal');
        if (!trigger || !dialog) return;
        const video = dialog.querySelector('.lcw-pvideo__modal-video > video');

        trigger.addEventListener('click', () => this.openModal(dialog, video, slide));
        dialog.querySelector('.lcw-pvideo__close')?.addEventListener('click', () => this.closeModal(dialog, video));
        dialog.addEventListener('click', (e) => { if (e.target === dialog) this.closeModal(dialog, video); });
        dialog.addEventListener('close', () => { if (video) video.pause(); });

        const prevNav = dialog.querySelector('[data-modal-nav="prev"]');
        const nextNav = dialog.querySelector('[data-modal-nav="next"]');
        if (slides.length <= 1) {
          prevNav && (prevNav.hidden = true);
          nextNav && (nextNav.hidden = true);
        } else {
          prevNav?.addEventListener('click', () => this.gotoSlide(slides, idx, -1));
          nextNav?.addEventListener('click', () => this.gotoSlide(slides, idx, 1));

          const videoWrap = dialog.querySelector('.lcw-pvideo__modal-video');
          if (videoWrap) {
            let startX = 0, startY = 0, tk = false;
            videoWrap.addEventListener('touchstart', (e) => { const t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY; tk = true; }, { passive: true });
            videoWrap.addEventListener('touchend', (e) => {
              if (!tk) return; tk = false;
              const t = e.changedTouches[0];
              const dx = t.clientX - startX, dy = t.clientY - startY;
              if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.gotoSlide(slides, idx, dx < 0 ? 1 : -1);
            }, { passive: true });
          }
        }

        dialog.querySelector('[data-action="playpause"]')?.addEventListener('click', () => {
          if (!video) return;
          video.paused ? video.play() : video.pause();
        });
        dialog.querySelector('[data-action="mute"]')?.addEventListener('click', () => {
          if (!video) return;
          video.muted = !video.muted;
          dialog.classList.toggle('is-muted', video.muted);
        });
        if (video) {
          video.addEventListener('play', () => dialog.classList.add('is-playing'));
          video.addEventListener('pause', () => dialog.classList.remove('is-playing'));
          this.bindTimeline(dialog, video);
        }

        dialog.querySelectorAll('.lcw-pvideo__atc-form form').forEach((form) => {
          form.addEventListener('submit', () => this.trackAddToCart(slide));
        });
      });
    }

    bindTimeline(dialog, video) {
      const timeline = dialog.querySelector('.lcw-pvideo__timeline');
      const fill = dialog.querySelector('.lcw-pvideo__timeline-fill');
      if (!timeline || !fill) return;
      video.addEventListener('timeupdate', () => {
        fill.style.width = (video.duration ? (video.currentTime / video.duration) * 100 : 0) + '%';
      });
      timeline.addEventListener('click', (e) => {
        const rect = timeline.getBoundingClientRect();
        const ratio = Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width));
        if (video.duration) video.currentTime = ratio * video.duration;
      });
    }

    openModal(dialog, video, slide) {
      dialog.showModal();
      if (video) {
        video.muted = false;
        dialog.classList.remove('is-muted');
        video.play().then(() => dialog.classList.add('is-playing')).catch(() => {
          video.muted = true; dialog.classList.add('is-muted'); video.play().catch(() => {});
        });
      }
      this.trackOpen(slide);
    }

    closeModal(dialog, video) {
      if (video) video.pause();
      dialog.close();
    }

    gotoSlide(slides, idx, dir) {
      const cur = slides[idx];
      const curDialog = cur.querySelector('.lcw-pvideo__modal');
      const curVideo = curDialog.querySelector('.lcw-pvideo__modal-video > video');
      const n = (idx + dir + slides.length) % slides.length;
      const nx = slides[n];
      const nxDialog = nx.querySelector('.lcw-pvideo__modal');
      const nxVideo = nxDialog.querySelector('.lcw-pvideo__modal-video > video');
      this.closeModal(curDialog, curVideo);
      requestAnimationFrame(() => this.openModal(nxDialog, nxVideo, nx));
    }

    publish(name, data) {
      if (!this.trackingOn) return;
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, data);
        }
      } catch (e) {}
    }
    dataFrom(slide) {
      const el = slide.querySelector('[data-product-id]') || slide;
      const slides = Array.from(this.querySelectorAll('.lcw-pvideo__slide'));
      return {
        product_id: el.dataset.productId,
        product_title: el.dataset.productTitle,
        price: parseFloat(el.dataset.productPrice) || undefined,
        list_id: this.listId,
        list_name: 'LCW PDP Video',
        index: slides.indexOf(slide),
      };
    }
    setupImpressions() {
      if (!this.trackingOn || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && !e.target.dataset.lcwViewed) {
            e.target.dataset.lcwViewed = '1';
            this.publish('lcw_video_view', this.dataFrom(e.target));
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.5 });
      this.querySelectorAll('.lcw-pvideo__slide').forEach((s) => io.observe(s));
    }
    trackOpen(slide) { this.publish('lcw_video_open', this.dataFrom(slide)); }
    trackAddToCart(slide) { this.publish('lcw_video_atc', this.dataFrom(slide)); }
  }
  if (!customElements.get('lcw-pdp-video')) customElements.define('lcw-pdp-video', LcwPdpVideo);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lcw-resultados-grupo"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function easeOutCubic(p) { return 1 - Math.pow(1 - p, 3); }

    function animateNumber(numEl, target, suffix, duration) {
      var start = performance.now();
      function frame(now) {
        var p = Math.min((now - start) / duration, 1);
        numEl.textContent = Math.round(easeOutCubic(p) * target) + suffix;
        if (p < 1) requestAnimationFrame(frame);
        else numEl.textContent = target + suffix;
      }
      requestAnimationFrame(frame);
    }

    function reveal(item, delay) {
      if (item.dataset.lcwDone) return;
      item.dataset.lcwDone = '1';

      var root = item.closest('[data-lcw-results]');
      var noAnim = !root || root.hasAttribute('data-no-anim') || reduce;
      var mode = root ? (root.getAttribute('data-line-fill') || 'reveal') : 'reveal';
      var duration = parseInt(getComputedStyle(root).getPropertyValue('--lcw-duration'), 10) || 700;

      var numEl = item.querySelector('[data-lcw-number]');
      var fillEl = item.querySelector('.lcw-result__line-fill');
      var target = parseFloat(numEl.getAttribute('data-target')) || 0;
      var suffix = numEl.getAttribute('data-suffix') || '';
      var pct = parseFloat(getComputedStyle(item).getPropertyValue('--lcw-item-pct')) || 0;
      var scale = mode === 'proportional' ? pct : 1;

      function run() {
        item.classList.add('is-visible');
        if (noAnim) {
          numEl.textContent = target + suffix;
          fillEl.style.transition = 'none';
          fillEl.style.transform = 'scaleX(' + scale + ')';
        } else {
          animateNumber(numEl, target, suffix, duration);
          requestAnimationFrame(function () {
            fillEl.style.transform = 'scaleX(' + scale + ')';
          });
        }
      }

      if (delay && !noAnim) setTimeout(run, delay);
      else run();
    }

    function initRoot(root) {
      if (root.dataset.lcwBound) return;
      root.dataset.lcwBound = '1';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-lcw-item]'));
      var noAnim = root.hasAttribute('data-no-anim') || reduce || !('IntersectionObserver' in window);

      if (noAnim) {
        items.forEach(function (it) { reveal(it, 0); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            items.forEach(function (it, i) { reveal(it, i * 90); });
            io.disconnect();
          }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }

    function boot() {
      document.querySelectorAll('[data-lcw-results]').forEach(initRoot);
    }

    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);

    // Theme editor: re-escaneia ao adicionar/recarregar seção ou bloco
    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
